import choiSmog from "../../assets/images/choi-smog.jpg";

export const servicePhotos = [
  choiSmog,
  "https://s3-media0.fl.yelpcdn.com/bphoto/5Fd45_OizXQsqw14obkslg/o.jpg",
  "https://s3-media0.fl.yelpcdn.com/bphoto/k2_SCHUty5nVGVytFvlmVg/o.jpg",
  "https://s3-media0.fl.yelpcdn.com/bphoto/oX3CydpF_VhmBFKaQkZ9fA/o.jpg",
];
